import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import React from 'react';
import { useStyling } from '../Theme';
import Toast from './Toast';

export default function AppToast() {
    const { theme } = useStyling();

    const styledTheme = {
        error: theme.palette.error,
        warning: theme.palette.warning,
        success: theme.palette.success
    };

    return (
        <EmotionThemeProvider theme={styledTheme}>
            <Toast />
        </EmotionThemeProvider>
    );
}
